import { render, staticRenderFns } from "./aCarDetailApplySpace.vue?vue&type=template&id=156570de&scoped=true"
import script from "./aCarDetailApplySpace.vue?vue&type=script&lang=js"
export * from "./aCarDetailApplySpace.vue?vue&type=script&lang=js"
import style0 from "./aCarDetailApplySpace.vue?vue&type=style&index=0&id=156570de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156570de",
  null
  
)

export default component.exports